import type { FormDefinition, FormDefinitionDraft, FormTemplate } from '../../types/forms'

const cloneTemplateSchema = (template: FormTemplate | null | undefined) => {
  const idMap = new Map((template?.fields ?? []).map((field) => [field.id, crypto.randomUUID()]))
  return {
    fields: (template?.fields ?? []).map((field, index) => ({ ...structuredClone(field), id: idMap.get(field.id) ?? crypto.randomUUID(), order: index })),
    rules: (template?.logic.rules ?? []).map((rule) => ({ ...structuredClone(rule), id: crypto.randomUUID(), when: { ...rule.when, fieldId: idMap.get(rule.when.fieldId) ?? rule.when.fieldId }, then: { ...rule.then, targetFieldId: idMap.get(rule.then.targetFieldId) ?? rule.then.targetFieldId } })),
  }
}

export const hydrateBuilderDraft = (workspaceId: string, userId: string, sourceForm?: FormDefinition | null, template?: FormTemplate | null): FormDefinitionDraft => {
  const clonedTemplate = cloneTemplateSchema(template)
  return {
    id: sourceForm?.id ?? crypto.randomUUID(),
    workspaceId,
    title: sourceForm?.title ?? template?.title ?? 'Untitled form',
    description: sourceForm?.description ?? template?.description ?? '',
    fields: sourceForm?.fields.map((field) => structuredClone(field)) ?? clonedTemplate.fields,
    logic: sourceForm ? structuredClone(sourceForm.logic) : { version: 1, rules: clonedTemplate.rules },
    theme: sourceForm ? structuredClone(sourceForm.theme) : template ? structuredClone(template.theme) : { accentColor: '#8b5cf6', density: 'COMPACT' }, // mosaic-keep: data (form draft default theme accent color)
    lifecycleStatus: sourceForm?.lifecycleStatus ?? 'DRAFT',
    submissionCount: sourceForm?.submissionCount ?? 0,
    deadline: sourceForm?.deadline ?? null,
    isLocked: sourceForm?.isLocked ?? false,
    createdBy: sourceForm?.createdBy ?? userId,
  }
}
